module.exports = __webpack_public_path__ + "static/media/Portrait-10242.808949ee.jpg";